import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Bullhorn from '../../../svg/Bullhorn.js';
import Formsy from 'formsy-react';
import FormsySelectMui from '../../form/FormsySelectMui';

const referOptions = [
  { value: 'google', label: 'Google Search' },
  { value: 'word_of_mouth', label: 'Word of Mouth' },
  { value: 'event', label: 'Culinistas Event' },
  { value: 'article', label: 'Article / Publication' },
  { value: 'social', label: 'Social Media' }
];

class Reference extends Component {
  state = {
    client: {
      refer: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { refer } = this.state.client;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="One last thing!"
          subline="How did you hear about The Culinistas?"
          icon={<Bullhorn />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="refer"
                placeholder="Select one"
                value={refer}
                options={referOptions}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ client: { ...this.state.client, [name]: value } });
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;
    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default Reference;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Reference.js